module.exports = __webpack_public_path__ + "static/fullContent-e9cfda4ef45223cc8977ef51e0ae46a2.svg";